<template>
  <div id="app">
    <div class="header">
      <div class="left-info">
        <div class="thumbnail">
          <img src="./assets/mazu.jpg" alt="">
        </div>
        <div class="name-info">
          <div class="name">
            <a target="_blank" href="https://www.facebook.com/themazhou/posts/307433766601772">媽祖</a>
          </div>
          <div class="time">
            4月17日下午6:12 ·
            <i class="global-icon"></i>
          </div>
        </div>
      </div>
      <div class="right-info"></div>
    </div>
    <div class="content">
      我根本沒說。
    </div>
    <div class="feedback-info">
      <div class="feedback-emojis">
        <i class="icons like-icon"></i>
        <i class="icons haha-icon"></i>
        <i class="icons love-icon"></i>
        鍋苔冥、憨摑娛和其他1.6 萬人
      </div>
      <div class="threads-and-share">
        <div class="threads">
          1,534則留言
        </div>
        <div class="share">
          2,953次分享
        </div>
      </div>
    </div>
    <div class="feedback-action">
      <div class="fb-wrapper">
        <i class="fb-icon thumb-up"></i> 讚
      </div>
      <div class="fb-wrapper">
        <i class="fb-icon response"></i> 回應
      </div>
      <div class="fb-wrapper">
        <i class="fb-icon share"></i> 分享
      </div>
    </div>
    <div class="comments">
      <div class="relevant">
        最相關
        <i class="relevant-icon"></i>
      </div>
      <div class="my-comment-wrapper">
        <div class="my-avatar">
          <img src="./assets/goldxfive.png" alt="">
        </div>
        <div class="my-comment">
          <div class="my-comment-placeholder">
            <input type="text" placeholder="留言……">
          </div>
          <div class="my-comment-emojis">
            <span class="add-emojis"></span>
            <span class="add-photo"></span>
            <span class="add-gif"></span>
            <span class="add-sticker"></span>
          </div>
        </div>
      </div>
      <!-- dingding -->
      <div class="people-comment-wrapper">
        <div class="people-avatar">
          <img src="./assets/dingding.png" alt="">
        </div>
        <div class="people-comment">
          <div class="people-comment-container">
            <div class="people-name">
              <a target="_blank" href="https://www.youtube.com/watch?v=_97bLScvHWs">叮守鐘</a>
            </div>
            <div class="people-saying">可以托夢讓我重選台北市長嗎？</div>
          </div>
          <div class="comment-reactions">
            <i class="icons like-icon"></i>
            <i class="icons ohhh-icon"></i>
            <span class="number">404</span>
          </div>
        </div>
      </div>
      <div class="like-and-response-wrapper">
        <div class="like-comment">
          <a>讚</a>
          <span class="nbsp">·</span>
        </div>
        <div class="response-comment">
          <a>回覆</a>
          <span class="nbsp">·</span>
        </div>
        <div class="days-comment">2018年11月24日</div>
      </div>
      <!-- 台灣公具伯 -->
      <div class="people-comment-wrapper">
        <div class="people-avatar">
          <img src="./assets/toolman.png" alt="">
        </div>
        <div class="people-comment">
          <div class="people-comment-container">
            <div class="people-name tool-man">
              <a target="_blank" href="https://www.facebook.com/jingping.tw/">台灣公具伯 汪進坪</a>
              <i class="blue-check"></i>
            </div>
            <div class="people-saying">這個我想，要查證比較難啦</div>
          </div>
          <div class="comment-reactions">
            <i class="icons like-icon"></i>
            <i class="icons haha-icon"></i>
            <i class="icons ohhh-icon"></i>
            <span class="number">529</span>
          </div>
        </div>
      </div>
      <div class="like-and-response-wrapper">
        <div class="like-comment">
          <a>讚</a>
          <span class="nbsp">·</span>
        </div>
        <div class="response-comment">
          <a>回覆</a>
          <span class="nbsp">·</span>
        </div>
        <div class="days-comment">4天</div>
      </div>
      <!-- English -->
      <div class="people-comment-wrapper">
        <div class="people-avatar">
          <img src="./assets/english.png" alt="">
        </div>
        <div class="people-comment">
          <div class="people-comment-container">
            <div class="people-name">
              <a target="_blank" href="https://www.facebook.com/tsaiingwen/">寀應彣</a>
              <i class="blue-check"></i>
            </div>
            <div class="people-saying">我也這麼覺得</div>
          </div>
          <div class="comment-reactions">
            <i class="icons like-icon"></i>
            <i class="icons haha-icon"></i>
            <span class="number">1.2 萬</span>
          </div>
        </div>
      </div>
      <div class="like-and-response-wrapper">
        <div class="like-comment">
          <a>讚</a>
          <span class="nbsp">·</span>
        </div>
        <div class="response-comment">
          <a>回覆</a>
          <span class="nbsp">·</span>
        </div>
        <div class="days-comment">4天</div>
      </div>
      <!-- 鍋苔冥 -->
      <div class="people-comment-wrapper">
        <div class="people-avatar">
          <img src="./assets/terry.png" alt="">
        </div>
        <div class="people-comment">
          <div class="people-comment-container">
            <div class="people-name pot-man">
              <a target="_blank" href="https://www.facebook.com/TerryGou1018/">鍋苔冥</a>
              <i class="blue-check"></i>
            </div>
            <div class="people-saying">謝謝樓主托夢，三樓的民主不能當飯吃！</div>
          </div>
          <div class="comment-reactions">
            <i class="icons angry-icon"></i>
            <span class="number">87</span>
          </div>
        </div>
      </div>
      <div class="like-and-response-wrapper">
        <div class="like-comment">
          <a>讚</a>
          <span class="nbsp">·</span>
        </div>
        <div class="response-comment">
          <a>回覆</a>
          <span class="nbsp">·</span>
        </div>
        <div class="days-comment">4天</div>
      </div>
      <!-- 發大財 -->
      <div class="people-comment-wrapper">
        <div class="people-avatar">
          <img src="./assets/korean-fish.png" alt="">
        </div>
        <div class="people-comment">
          <div class="people-comment-container">
            <div class="people-name korean-fish">
              <a target="_blank" href="https://www.facebook.com/twherohan/">憨摑娛</a>
              <i class="blue-check"></i>
            </div>
            <div class="people-saying">樓上為什麼不考慮吃個包子呢？</div>
          </div>
          <div class="comment-reactions">
            <i class="icons like-icon"></i>
            <i class="icons angry-icon"></i>
            <span class="number">987</span>
          </div>
        </div>
      </div>
      <div class="like-and-response-wrapper">
        <div class="like-comment">
          <a>讚</a>
          <span class="nbsp">·</span>
        </div>
        <div class="response-comment">
          <a>回覆</a>
          <span class="nbsp">·</span>
        </div>
        <div class="days-comment">3天</div>
      </div>
      <!-- 摩天輪進度條 -->
      <div class="people-comment-wrapper">
        <div class="people-avatar">
          <img src="./assets/wheel.png" alt="">
        </div>
        <div class="people-comment">
          <div class="people-comment-container">
            <div class="people-name">
              <a target="_blank" href="https://www.facebook.com/CareLoveFerrisWheelEveryday/">每天關心愛情摩天輪的興建狀況</a>
            </div>
            <div class="people-saying">五樓，我快等不及了</div>
          </div>
          <div class="comment-reactions">
            <i class="icons like-icon"></i>
            <i class="icons haha-icon"></i>
            <span class="number">502</span>
          </div>
        </div>
      </div>
      <div class="like-and-response-wrapper">
        <div class="like-comment">
          <a>讚</a>
          <span class="nbsp">·</span>
        </div>
        <div class="response-comment">
          <a>回覆</a>
          <span class="nbsp">·</span>
        </div>
        <div class="days-comment">2天</div>
      </div>
      <!-- 找到田 -->
      <div class="people-comment-wrapper university">
        <div class="people-avatar">
          <img src="./assets/land.jpg" alt="">
        </div>
        <div class="people-comment">
          <div class="people-comment-container university">
            <div class="people-name">
              <a target="_blank">找到田大學</a>
            </div>
            <div class="people-saying university">五樓要不要藉這個機會在神明的面前澄清一下？</div>
            <img class="inner-image" src="https://i.imgur.com/wvWFAMT.png" alt="">
          </div>
          <div class="comment-reactions">
            <i class="icons like-icon"></i>
            <i class="icons cry-icon"></i>
            <span class="number">875</span>
          </div>
        </div>
      </div>
      <div class="like-and-response-wrapper">
        <div class="like-comment">
          <a>讚</a>
          <span class="nbsp">·</span>
        </div>
        <div class="response-comment">
          <a>回覆</a>
          <span class="nbsp">·</span>
        </div>
        <div class="days-comment">1天</div>
      </div>
      <!-- 整理魔法 -->
      <div class="people-comment-wrapper university">
        <div class="people-avatar">
          <img src="./assets/sparkJoy.png" alt="">
        </div>
        <div class="people-comment">
          <div class="people-comment-container">
            <div class="people-name">
              <a target="_blank">尛理惠的整理魔法</a>
              <i class="blue-check"></i>
            </div>
            <div class="people-saying">
              臺灣的碰有打家好～
            </div>
          </div>
          <div class="people-comment-container">
            <div class="people-saying secret-magic">
              今天要來教打家年後清理臉書版面的小妙招分享
            </div>
          </div>
          <div class="people-comment-container">
            <div class="people-saying">
              1. 點進去五樓的粉絲團
            </div>
          </div>
          <div class="people-comment-container">
            <div class="people-saying">
              2. 啊～原來ＸＸＸ和其他 10 位朋友都說這個讚
            </div>
          </div>
          <div class="people-comment-container">
            <div class="people-saying">
              3. 果斷斷開好友連結
            </div>
          </div>
          <div class="people-comment-container">
            <div class="people-saying hashtag">
              #怦然心動的臉書整理魔法
            </div>
          </div>
          <div class="people-comment-container">
            <div class="people-saying hashtag hashtag-last">
              #簡單三步驟打家學會了嗎
            </div>
          </div>
          <div class="comment-reactions">
            <i class="icons like-icon"></i>
            <i class="icons haha-icon"></i>
            <span class="number">789</span>
          </div>
        </div>
      </div>
      <div class="like-and-response-wrapper">
        <div class="like-comment">
          <a>讚</a>
          <span class="nbsp">·</span>
        </div>
        <div class="response-comment">
          <a>回覆</a>
          <span class="nbsp">·</span>
        </div>
        <div class="days-comment">2天</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style lang="sass">
body
  display: flex
  justify-content: center
  align-items: center
  background: #e9ebee

#app
  min-width: 500px
  height: 1105px
  background: white
  border: 1px solid #dddfe2
  border-radius: 4px

  .header
    display: flex
    justify-content: space-between
    padding: 12px 12px 0

    .left-info
      display: flex
      justify-content: center
      align-items: center

      .thumbnail img
        display: block
        width: 40px
        height: 40px
        border-radius: 50%
        margin-right: 8px

      .name-info
        .name
          cursor: pointer
          font-weight: 600

          a
            text-decoration: none
            color: #365899

            &:hover
              text-decoration: underline

        .time
          color: #616770
          font-size: 13px
          display: flex
          align-items: center
          justify-content: center
          font-family: Microsoft JhengHei

          .global-icon
            width: 12px
            height: 12px
            background-position: -28px -499px
            background-image: url("./assets/global.png")
            background-size: 73px 540px
            background-repeat: no-repeat
            display: inline-block
            margin-left: 4px

    .right-info
      background-image: url("./assets/menu.png")
      background-repeat: no-repeat
      background-size: 500px 287px
      background-position: -242px -245px
      width: 20px
      height: 20px
      cursor: pointer

  .content
    font-size: 25px
    font-weight: 300
    letter-spacing: 0
    line-height: 28px
    margin: 0 0 7px 0
    padding: 12px 12px 0

  .feedback-info
    display: flex
    justify-content: space-between
    border-bottom: 1px solid #dadde1
    margin: 10px 12px 0 12px
    padding: 0 0 10px 0

    .threads-and-share
      display: flex
      font-size: 14px
      font-family: Microsoft JhengHei

    .feedback-emojis
      // margin-left: -100px;
      min-width: 100px
      font-size: 14px
      display: flex
      align-items: center

      .icons
        cursor: pointer
        background: #fff
        border-radius: 12px
        box-shadow: 2px 0 white
        overflow: hidden
        background-image: url("./assets/fb-emojis.png")
        background-repeat: no-repeat
        background-size: 49px 660px
        height: 16px
        width: 16px
        line-height: 16px
        display: inline-block
        margin-left: -2px
        margin-right: 2px

        &.like-icon
          background-position: 0 -526px
          z-index: 3

        &.haha-icon
          background-position: -17px -475px
          z-index: 2

        &.love-icon
          background-position: -17px -492px
          margin-right: 4px

    .threads-and-share
      .share
        margin-left: 8px

  .feedback-action
    display: flex
    justify-content: space-around
    align-items: center
    font-weight: 600
    font-size: 14px
    height: 32px
    color: #606770
    margin: 0 12px
    min-height: 32px
    padding: 4px 0

    div
      cursor: pointer

    .fb-wrapper
      display: flex
      justify-content: center
      align-items: center
      width: 100%
      min-height: 32px

      &:hover
        background-color: rgba(29, 33, 41, 0.04)
        border-radius: 2px
        text-decoration: none

      .fb-icon
        width: 18px
        height: 18px
        display: inline-block
        background-repeat: no-repeat
        margin: 0 6px 0 0

        &.thumb-up
          background-image: url("./assets/thumbUp.png")
          background-size: 55px 237px
          background-position: -19px -131px

        &.response
          background-position: -42px -249px
          background-image: url("./assets/responseShare.png")
          background-size: 161px 376px
          background-position: -42px -249px

        &.share
          background-image: url("./assets/responseShare.png")
          background-size: 161px 376px
          background-position: -61px -249px

  .comments
    margin: 0 12px
    border-top: 1px solid #dadde1

    .relevant
      display: flex
      align-items: center
      margin: 8px 0
      color: #444950
      font-size: 14px
      cursor: pointer

      .relevant-icon
        background-image: url("./assets/relevant.png")
        background-repeat: no-repeat
        background-size: 500px 287px
        background-position: -408px -270px
        display: inline-block
        height: 12px
        margin-left: 2px
        margin-top: 2px
        vertical-align: top
        width: 12px

  .my-comment-wrapper
    display: flex
    align-items: center

    .my-avatar img
      height: 32px
      width: 32px
      border-radius: 50%
      display: block
      overflow: hidden
      margin-right: 6px

    .my-comment
      background-color: #f2f3f5
      border: 1px solid #ccd0d5
      border-radius: 16px
      display: flex
      justify-content: space-between
      align-items: center
      cursor: text
      flex: 1 1 auto
      line-height: 16px
      overflow: hidden
      padding: 7px 12px

      .my-comment-placeholder
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap !important
        color: #8d949e
        font-size: 14px

        input[type=text]
          width: 300px
          appearance: none
          -moz-appearance: none
          -webkit-appearance: none
          border-radius: 0
          -moz-border-radius: 0
          -webkit-border-radius: 0
          outline: none
          padding: 0
          border: 0px solid transparent
          background: transparent
          font-size: 14px

      .my-comment-emojis
        div
          padding: 8px 6px

        span
          display: inline-block
          background-image: url("./assets/my-comment.png")
          background-repeat: no-repeat
          background-size: 55px 237px
          height: 16px
          width: 16px
          margin-left: 10px
          cursor: pointer

          &.add-emojis
            background-position: -34px -169px

          &.add-photo
            background-position: -36px -150px

          &.add-gif
            background-position: -34px -186px

          &.add-sticker
            background-position: -34px -203px

  .people-comment-wrapper
    margin-top: 10px
    display: flex
    align-items: center

    &.university
      align-items: flex-start

    .people-avatar img
      height: 32px
      width: 32px
      border-radius: 50%
      display: block
      overflow: hidden
      margin-right: 6px

    .people-comment
      background-color: #f2f3f5
      border-radius: 18px
      color: #1c1e21
      line-height: 16px
      position: relative
      line-height: 16px
      padding: 8px 12px
      position: relative

      .people-comment-container
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap !important
        color: #1c1e21
        font-size: 14px
        display: flex

        &.university
          flex-direction: column

        .people-name
          font-weight: 600
          cursor: pointer
          margin-right: 4px

          a
            text-decoration: none
            color: #365899

          &:hover
            text-decoration: underline

          .blue-check
            margin-left: 4px
            background-image: url("./assets/blue-check.png")
            background-repeat: no-repeat
            background-size: 28px 195px
            background-position: 0 -165px
            height: 15px
            vertical-align: -2px
            width: 15px
            display: inline-block

        .people-saying
          &.university
            margin: 5px 0

          &.secret-magic
            margin: 12px 0 8px 0

          &.hashtag
            margin-top: 15px
            color: #365899
            cursor: pointer

            &.hashtag-last
              margin-top: 0

            &:hover
              text-decoration: underline

        .inner-image
          width: 360px
          height: 204px
          margin-bottom: 5px

      .comment-reactions
        position: absolute
        bottom: -12px
        right: 2px
        z-index: 9999
        display: flex
        align-items: center
        background: #fff
        border-radius: 10px
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2)
        color: #8d949e
        font-size: 12px
        font-weight: normal
        padding: 2px 1px 2px 4px

        .icons
          cursor: pointer
          background: #fff
          border-radius: 12px
          box-shadow: 2px 0 white
          overflow: hidden
          background-image: url("./assets/fb-emojis.png")
          background-repeat: no-repeat
          background-size: 49px 660px
          height: 16px
          width: 16px
          line-height: 16px
          display: inline-block
          margin-left: -2px
          margin-right: 2px

          &.like-icon
            background-position: 0 -526px
            z-index: 3

          &.haha-icon
            background-position: -17px -475px
            z-index: 2

          &.ohhh-icon
            background-position: 0 -543px
            margin-right: 4px

          &.angry-icon
            background-position: -17px -441px

          &.cry-icon
            background-position: -17px -509px

        .number
          color: #777d88
          padding: 0 3px 0 2px
          font-size: 12px
          line-height: 16px
          font-family: Microsoft JhengHei

  .like-and-response-wrapper
    display: flex
    color: #90949c
    font-size: 13px
    line-height: 13px
    margin-top: 5px
    margin-left: 50px

    .nbsp
      margin-left: 2px
      color: #8d949e

    .like-comment,
    .response-comment
      color: #365899
      cursor: pointer
      margin-right: 2px

      a:hover
        text-decoration: underline
</style>
